import React, { Component } from 'react'
import { Logo } from '../../components/Layout'
import { ResetForm } from './components'
import { Redirect } from 'react-router-dom'

export default class extends Component {
  render () {
    const { organization, resetPassword } = this.props

    return (
      organization.data.id === 0
        ? <Redirect to='/' />
        : <div className='login app__login'>
          <div className='login__container'>
            <div className='login__wrapper'>
              <div className='login__logo'>
                <Logo width='64' />
              </div>
              <div className='login__content'>
                <ResetForm
                  organization={organization}
                  resetPassword={resetPassword} />
              </div>
            </div>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Reset/Reset.jsx